<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { SIGNUP_URL } from "@/seo/config";

const { t } = useI18n();
</script>

<template>
  <section
    id="hero"
    class="px-5 pt-24 pb-16 text-center md:px-12 md:pt-24 md:pb-16"
    style="background: radial-gradient(circle at 50% 30%, #ffffff 0%, #fdfaf2 70%)"
  >
    <div class="mx-auto max-w-[var(--max-w-page)]">
      <!-- Headline -->
      <h1
        data-reveal
        class="fade-up mx-auto max-w-[640px] text-[32px] leading-[1.1] font-bold tracking-[-0.02em] text-[var(--color-text-primary)] md:text-[52px]"
        style="font-family: var(--font-display)"
      >
        {{ t("hero.headline") }}
      </h1>

      <!-- Subheadline -->
      <p
        data-reveal
        data-reveal-delay="2"
        class="fade-up mx-auto mt-5 max-w-[520px] text-base leading-[1.7] text-[var(--color-text-secondary)] md:text-lg"
      >
        {{ t("hero.subheadline") }}
        <br />{{ t("hero.subheadlineLine2") }}
      </p>

      <!-- CTAs -->
      <div
        data-reveal
        data-reveal-delay="3"
        class="fade-up mt-7 flex flex-col items-center gap-4 md:flex-row md:justify-center md:gap-6"
      >
        <a
          :href="SIGNUP_URL"
          class="w-full rounded-full bg-[var(--color-primary)] px-8 py-3.5 text-center text-base font-semibold text-white transition-colors hover:bg-[var(--color-primary-hover)] md:w-auto"
        >
          {{ t("hero.cta") }}
        </a>
        <a
          href="#solution"
          class="text-[15px] font-normal text-[var(--color-primary)] transition-colors hover:underline"
        >
          {{ t("hero.seeHow") }}
        </a>
      </div>

      <!-- Supporting detail -->
      <p
        data-reveal
        data-reveal-delay="3"
        class="fade-up mt-3 text-[13px] font-medium text-[var(--color-text-muted)]"
      >
        {{ t("hero.noCard") }}
      </p>

      <div
        data-reveal
        data-reveal-delay="5"
        class="fade-up-lg mx-auto mt-8 max-w-[800px] overflow-hidden rounded-2xl border border-[rgba(31,29,27,0.06)] md:mt-12"
        style="
          box-shadow:
            0 24px 48px rgba(31, 29, 27, 0.1),
            0 8px 16px rgba(31, 29, 27, 0.06);
        "
      >
        <img
          src="/screenshots/visual-journey.webp"
          :alt="t('hero.screenshotPlaceholder')"
          width="2000"
          height="1500"
          class="block aspect-[16/10] w-full object-cover"
          fetchpriority="high"
          decoding="async"
          draggable="false"
        />
      </div>
    </div>
  </section>
</template>
